<template>
    <div v-show="visible">
        <el-dialog :title="form.title" :visible.sync="visible"
            v-loading="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            element-loading-background = "rgba(255, 255,255,0.7)"  
            :close-on-click-modal="false" 
            :before-close="dialogClose"  
            width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
               <el-form-item   prop="checkStatus" label="审核状态">
                    <el-radio-group v-model="form.checkStatus">
                        <el-radio :label="2" >通过</el-radio>
                        <el-radio :label="0">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item prop="checkRemark" label="审核备注">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.checkRemark"
                        maxlength="100"
                        show-word-limit>
                    </el-input>
                </el-form-item> 
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
                <!-- <el-button type="primary" @click="save(2)">确定<span style="color:red;">(跳过验证,不推荐)</span></el-button> -->
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                loadingText:"",

                visible: false,
                form:{
                    title:"",
                    id:"",
                    checkRemark:"",
                    checkStatus:2,
                },
                rules: {
                    checkRemark: [
                        { required: true, message: '审核备注不可以为空', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
             init(idStr){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id = idStr;
                // 如果多个ID，标题改成“批量审核”；否则，标题改成“审核”
                let idArr=idStr.split(',');
                if(idArr.length > 1){
                    this.form.title='批量审核';
                }else{
                    this.form.title='审核';
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        let url= this.commodityOrderUpdatetUrl;
                        let data = {
                            id: this.form.id,
                            checkStatus: this.form.checkStatus,
                            checkRemark: this.form.checkRemark,
                        };

                        // console.log("审核信息:"+JSON.stringify(data))
                        // return;
                        this.loading=true;
                        this.loadingText="审核中...";
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/page/shop/order/Check.vue